import { render, staticRenderFns } from "./goodsMonitor.vue?vue&type=template&id=dd51dcf0&scoped=true"
import script from "./goodsMonitor.vue?vue&type=script&lang=js"
export * from "./goodsMonitor.vue?vue&type=script&lang=js"
import style0 from "./goodsMonitor.vue?vue&type=style&index=0&id=dd51dcf0&prod&lang=scss&scoped=true"
import style1 from "./goodsMonitor.vue?vue&type=style&index=1&id=dd51dcf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd51dcf0",
  null
  
)

export default component.exports